'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

import {
  getPageCategory,
  sendGTMEvent,
  type GTMBaseParams
} from '@/fo/api/gtm';

import { pushCookieChecker } from '../utils/cookieConsentEvents';

interface FeatureCookieConsentVirtualPageProps {
  /** Обход согласия (webview или отключено ограничение) */
  bypass: boolean;
  baseParams: Omit<GTMBaseParams, 'pageCategory'>;
}

/** Отправляет CookieChecker при переходе на виртуальные страницы */
export const FeatureCookieConsentVirtualPage = ({
  bypass,
  baseParams
}: FeatureCookieConsentVirtualPageProps) => {
  const pathname = usePathname();
  const isFirstNavigation = useRef(true);

  useEffect(() => {
    if (isFirstNavigation.current) {
      isFirstNavigation.current = false;
      return;
    }

    pushCookieChecker(bypass);
    sendGTMEvent({ ...baseParams, pageCategory: getPageCategory(pathname) });
    sendGTMEvent({
      event: 'updatevirtualpath',
      virtualPageURL: pathname,
      virtualPageTitle: document.title
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, bypass]);

  return null;
};
